<template>
    <div class="layout-container">
        <el-tabs type="border-card">
            <el-tab-pane label="用户列表">
                <div style="background: #ffffff;position:relative;">
                    <div class="search-condition-con" :class="isShowMore && 'show'">
                        <div class="search-condition">
                            <span class="label">代理商</span>
                            <div class="input-condition">
                                <factor-auto-complete v-model="condition.factor_id" clearable></factor-auto-complete>
                            </div>
                        </div>
                        <div class="search-condition">
                            <span class="label">站点</span>
                            <div class="input-condition">
                                <site-auto-complete v-model="condition.site_id" :factor-id="condition.factor_id" clearable></site-auto-complete>
                            </div>
                        </div>

                        <div class="search-condition">
                            <span class="label">用户</span>
                            <div class="input-condition">
                                <admin-auto-complete v-model="condition.id" :factor-id="condition.factor_id" clearable></admin-auto-complete>
                            </div>
                        </div>
                        <div class="search-condition">
                            <span class="label">用户状态</span>
                            <div class="input-condition">
                                <el-select v-model="condition.status">
                                    <el-option value="-1" label="全部" checked></el-option>
                                    <el-option value="0" label="启用"></el-option>
                                    <el-option value="1" label="禁用"></el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>
                    <a class="el-icon-d-arrow-left search-arrow-down" :class="!isShowMore && 'hide'" @click.stop="isShowMore = !isShowMore"></a>
                    <div class="btn-condition">
                        <el-button type="primary" @click="handleSearch()">查 询</el-button>
                        <el-button  @click="resetSearch()">清空条件</el-button>
                    </div>
                </div>

                <div class="clearfix" style="margin-bottom: 5px">
                    <el-button-group class="floatR">
                        <el-tooltip class="item" effect="dark" content="新增代理商超级管理员" placement="top">
                            <el-button icon="el-icon-plus" @click="handleAdd()" v-permission="'user.factor-admins.add'"></el-button>
                        </el-tooltip>
                    </el-button-group>
                </div>
                <el-table
                        :data="list"
                        style="width: 100%"
                        :highlight-current-row="true"
                        stripe
                        tooltip-effect="dark"
                        ref="multipleTable"
                        v-loading="isLoading"
                        header-cell-class-name="table-back"
                >
                    <!--  -->
                    <!-- 表头：label对应展示的名称 prop对应返回数据列表中绑定的字段名 sortable:标识当前列是否允许排序 -->
                    <el-table-column  label="ID" prop="id" fixed></el-table-column>
                    <el-table-column  label="用户名" prop="account" fixed></el-table-column>
                    <el-table-column  label="姓名" prop="name"></el-table-column>
                    <el-table-column  label="代理商" prop="factor_name" width="300px"></el-table-column>
                    <el-table-column  label="代理商ID" prop="factor_id"></el-table-column>
                    <el-table-column  label="签约状态" prop="sign_status"></el-table-column>
                    <el-table-column  label="关联站点">
                        <template slot-scope="scope">
                            <span :title="scope.row.site_string">{{scope.row.site_str}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="是否启用" prop="status">
                        <template slot-scope="scope">
                            <el-switch active-color="#13ce66" v-model="scope.row.status" active-value='0' inactive-value='1'  @change="status => change(status, scope.row)"></el-switch>
                        </template>
                    </el-table-column>
                    <el-table-column  label="最后登录" prop="last_login_at" width="180px"></el-table-column>
                    <el-table-column  label="添加人" prop="creator_account"></el-table-column>
                    <el-table-column  label="更新时间" prop="updated_time" width="180px"></el-table-column>
                    <el-table-column  label="操作" width="180px"  fixed="right">
                        <template slot-scope="scope" >
                            <el-button size="mini" @click="openLog(scope.$index, scope.row)" v-permission="'user.factor-admins.login-log'"
                            >登录日志</el-button>
                            <el-button size="mini"  v-if="scope.row.sign_status==1" v-permission="'user.factor-admins.edit'"
                                       @click="openEdit(scope.$index, scope.row)"
                            >编辑</el-button>
                            <el-button type="danger" size="mini" v-if="scope.row.status==1 && scope.row.sign_status_name=='已解约' " v-permission="'user.factor-admins.delete'"
                                       @click="handleDelete(scope.$index, scope.row)"
                            >删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <!--  total：一共有多少条数据 page-size一个页面显示多少条数据 @current-change当点击分页数触发-->
                <template v-if="list.length > 0">
                    <!-- :total="list.length" -->
                    <el-pagination background layout="total,prev, pager, next" :current-page="condition.page"  :total="condition.total" :page-size="condition.per_page" @current-change="currentChange"></el-pagination>
                </template>
                <add ref="add" :callback="initData"></add>
                <edit ref="edit" :callback="initData"></edit>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import { getFactorsList, getFactorAdminList, modifyAdminStatus } from '@/service/user'
    import { parseTime } from '@/utils'
    import { getSite } from '@/service/site'
    import add from './component/add'
    import edit from './component/edit'
    import FactorAutoComplete from "../../../components/auto-complete/factor-auto-complete";
    import SiteAutoComplete from "../../../components/auto-complete/site-auto-complete";
    import AdminAutoComplete from "../../../components/auto-complete/admin-auto-complete";
    export default {
        name: "List",
        components: {
            AdminAutoComplete,
            SiteAutoComplete,
            FactorAutoComplete,
            add,
            edit,
        },
        data () {
            return {
                list: [],
                condition : {
                    status : '-1',
                    sign_status : '-1',
                    factor_id: null,
                    site_id : null,
                    id: null,
                    page : 1,
                    total : 0,
                    per_page : 10,
                    type: '1'
                },
                sites : [],
                factors : [],
                isLoading: false,
                isShowMore: false
            }
        },
        mounted () {
            this.condition = this.defaultConditions();
            this.initData()
        },
        methods: {
            defaultConditions() {
                return {
                    status : '-1',
                    sign_status : '-1',
                    factor_id: null,
                    site_id : null,
                    id: null,
                    page : 1,
                    total : 0,
                    per_page : 10,
                }
            },
            openLog (index, row){
                this.$router.push('login-log?id=' + row.id)
            },
            handleAdd(){
                this.$refs.add
                && this.$refs.add.open()
            },
            openEdit(index, row){
                this.$refs.edit
                && ( Object.assign(this.$refs.edit.userInfo, row))
                && this.$refs.edit.open()
            },
            handleSearch() {
                this.condition.page = 1;
                this.initData()
            },
            resetSearch() {
                this.condition = this.defaultConditions();
                this.initData()
            },
            /** 初始化数据请求 */
            async initData () {
                this.list = [];
                // 初始化之前设置当前页面的loading状态
                this.isLoading = true;
                // 模拟fetch请求数据....
                let query = {
                    status :  this.condition.status,
                    sign_status :  this.condition.sign_status,
                    page :  this.condition.page,
                    total :  this.condition.total,
                    per_page :  this.condition.per_page,
                };
                if (!!this.condition.factor_id) {
                    query.factor_id = this.condition.factor_id
                }
                if (!!this.condition.site_id) {
                    query.site_id = this.condition.site_id
                }
                if (!!this.condition.id) {
                    query.id = this.condition.id
                }
                await getFactorAdminList(query).then((data) => {
                    this.condition.total= parseInt(data.total);
                    this.condition.per_page = parseInt(data.per_page);
                    if (!!data.data !== true) {
                        this.list = [];
                        return
                    }
                    let listData = data.data;
                    for (let i in listData) {
                        let row = listData[i];
                        let sign_status = row.sign_status;
                        switch (sign_status) {
                            case 0:
                                row.sign_status_name = '待签约';
                                break;
                            case 1:
                                row.sign_status_name = '已签约';
                                break;
                            case 2:
                                row.sign_status_name = '已解约';
                                break;
                            default:
                                row.sign_status_name = '';
                        }
                        if (row.sites && Object.keys(row.sites).length > 0) {
                            row.site_str = Object.values(row.sites).filter((v, i) => i < 2).join(',');
                            row.site_string = Object.values(row.sites).join(',')
                        } else {
                            row.site_str = '--'
                        }
                        if (row.updated_at)  {
                            row.updated_time = parseTime(new Date(row.updated_at))
                        } else {
                            row.updated_time = ''
                        }
                        if (row.last_login_time)  {
                            row.last_login_time_string = parseTime(row.last_login_time * 1000)
                        } else {
                            row.last_login_time_string = ''
                        }
                        row.status = row.status.toString();
                        row.site_counts = row.sites.length > 0 ? row.sites.length : 0
                    }
                    this.list = listData

                });
                // 数据请求完毕取消当前页面的loading
                this.isLoading = false
            },
            currentChange (index) {
                this.condition.page = index;
                this.initData()
            },
            /** 监听到改变switch */
            change (status, data) {
                if (data.sign_status == '已解约') {
                    this.$message({
                        message: '关联代理商已解约，不可启用',
                        type: 'error',
                        duration: 3 * 1000
                    });
                    data.status = 1;
                    return false
                }
                if (status == '1') {
                    this.$confirm('此操作将禁用该超管用户登录，是否确认？', '提示').then(_ => {
                        let query = {
                            status : status
                        };
                        modifyAdminStatus(data.id, query).then((data) => {
                            this.$message({
                                message: '修改成功',
                                type: 'success',
                                duration: 3 * 1000
                            })
                        }).catch(err => {
                            this.$message({
                                message: err.message || '修改失败',
                                type: 'error',
                                duration: 3 * 1000
                            })
                        })
                    }).catch(_ => {
                        data.status = status == '1' ? '0' : '1'
                    })
                } else {
                    let query = {
                        status : status
                    };
                    modifyAdminStatus(data.id, query).then((data) => {
                        this.$message({
                            message: '修改成功',
                            type: 'success',
                            duration: 3 * 1000
                        })
                    }).catch(err => {
                        this.$message({
                            message: err.message || '修改失败',
                            type: 'error',
                            duration: 3 * 1000
                        })
                    })
                }

            },
            handleDelete(index, row) {
                this.$confirm('删除后，会同步删除该代理商下权限平台的所有分站用户，不可恢复，是否确认？', '提示').then(_ => {
                    let query = {
                        status : 2
                    };
                    modifyAdminStatus(row.id, query).then((data) => {
                        this.$message({
                            message: '删除成功',
                            type: 'success',
                            duration: 3 * 1000
                        });
                        this.list.splice(index, 1)
                    }).catch(err => {
                        this.$message({
                            message: err.message || '删除失败',
                            type: 'error',
                            duration: 3 * 1000
                        })
                    })
                }).catch(_ => {
                })
            },

        }
    }
</script>

<style scoped>

</style>
